export default __webpack_public_path__ + "505ca45f29a242c3ac4229fe011298cf.png";